<template>
  <div class="app-body">
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <el-card>
        <div slot="header" class="card-header">
          <div>合同信息</div>
        </div>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="合同编号：" prop="code">
              <el-input
                v-model="dataForm.code"
                placeholder="请输入合同编号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户：" prop="customerId">
              <customer
                v-model="dataForm.customerId"
                :disabled="canEditCustomer"
                :showBtn="!canEditCustomer"
              ></customer>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交易货币：" prop="currency">
              <currency v-model="dataForm.currency"></currency>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="expand">
          <el-col :span="8">
            <el-form-item label="签订日期：" prop="signTime">
              <el-date-picker
                v-model="dataForm.signTime"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择签订日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="交付日期：" prop="deadline">
              <el-date-picker
                v-model="dataForm.deadline"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择交付日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注：" prop="remark">
              <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <div class="flex justify-center hand">
          <i v-if="!expand" class="el-icon-arrow-down" @click="expand=!expand"></i>
          <i v-if="expand" class="el-icon-arrow-up"  @click="expand=!expand"></i>
        </div>
      </el-card>
      <el-card>
        <div slot="header" class="card-header">
          <div>合同明细</div>
          <div>
            <el-button
              size="mini"
              icon="el-icon-upload"
              @click="showCommonDialog()"
              type="warning"
              >导入合同明细</el-button
            >
            <el-button
              size="mini"
              icon="el-icon-plus"
              @click="showDetailSaveDialog()"
              type="primary"
              >增加明细</el-button
            >
          </div>
        </div>
        <el-table
          :data="dataForm.detailList"
          border
          style="width: 100%"
          :summary-method="getSummaries"
          show-summary
          @selection-change="detailSelectionChangeHandle"
        >
          <el-table-column
            type="index"
            label="行号"
            width="60"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column label="品番号" header-align="center" align="center">
            <template slot-scope="scope">
              <div>品番号： {{ scope.row.code }}</div>
              <div v-if="scope.row.skuCode">
                SKU编号： {{ scope.row.skuCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="品名" align="center">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column
            label="尺寸"
            prop="size"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.size }}
            </template>
          </el-table-column>
          <el-table-column
            label="颜色"
            prop="color"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.color }}
            </template>
          </el-table-column>
          <el-table-column
            label="合同数量"
            header-align="center"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.count }}
            </template>
          </el-table-column>
          <el-table-column
            label="合同单价"
            header-align="center"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.amount }}
            </template>
          </el-table-column>
          <el-table-column
            label="小计"
            header-align="center"
            align="center"
            width="140"
          >
            <template slot-scope="scope">{{
              computePrice(scope.row)
            }}</template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            width="160"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-remove"
                size="mini"
                @click="delRow(scope.$index, scope.row, 'detailList')"
              >
                移除
              </el-button>
              <el-button
                type="text"
                icon="el-icon-remove"
                size="mini"
                @click="showDetailSaveDialog(scope.row, scope.$index)"
              >
                修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-form>
    <div class="footer">
      <el-button @click="cancel()">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </div>
    <DetailSaveDialog
      ref="detailSaveDialog"
      @change="detailSaveHandle"
    ></DetailSaveDialog>
    <common-upload
      ref="commonUpload"
      @success="uploadSuccessHandler"
      uploadUrl="/trade/agreement/detail/import"
      templateUrl="/static/template/合同明细导入模板.xlsx"
      title="合同明细导入"
    ></common-upload>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import BigNumber from "bignumber.js";
import SingleFileUpload from "@/components/SingleFileUpload";
import SaveRule from "./save-rule";
import moment from "moment";
import DetailSaveDialog from "./detail-save.vue";
export default {
  mixins: [SaveRule],
  components: { SingleFileUpload, DetailSaveDialog },
  data() {
    return {
      id: "",
      projectId: "",
      dataForm: {},
      currentDetailIndex: [],
      detailSelections: [],
      expand:false
    };
  },
  computed: {
    canEditCustomer() {
      if (this.dataForm.id) {
        return true;
      }
      if (this.projectId) {
        return true;
      }
      return false;
    },
  },
  activated() {
    this.id = this.$route.query.id;
    this.init();
  },
  methods: {
    detailSelectionChangeHandle(val) {
      this.detailSelections = val;
      console.log("detailSelections", this.detailSelections);
    },
    uploadSuccessHandler(e) {
      if (e && e.length > 0) {
        e.forEach((item, index) => {
          item.id = index;
          item.bomList = [];
        });
      }
      this.dataForm.detailList = [...e];
    },
    //显示通用导入弹窗
    showCommonDialog() {
      this.$refs.commonUpload.init();
    },
    //显示明细编辑窗口
    showDetailSaveDialog(row, index) {
      this.currentDetailIndex = [index];
      if (row) {
        this.$refs.detailSaveDialog.dataForm = this.$clone(row);
        this.$refs.detailSaveDialog.init(false);
      } else {
        this.$refs.detailSaveDialog.init(true);
      }
    },
    //明细编辑回调
    detailSaveHandle(e) {
      if (this.currentDetailIndex && this.currentDetailIndex.length > 0) {
        e.id = this.dataForm.detailList[this.currentDetailIndex[0]].id;
        this.$set(
          this.dataForm.detailList,
          this.currentDetailIndex[0],
          this.$clone(e)
        );
      } else {
        e.id = this.dataForm.detailList.length;
        this.dataForm.detailList.push(this.$clone(e));
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      sums[0] = "合计";
      let totalAmount = new BigNumber(0);
      data.forEach((row) => {
        const count = new BigNumber(row["count"]);
        const price = new BigNumber(row["amount"]);
        if (count.isNaN() || price.isNaN()) {
          return;
        }
        totalAmount = totalAmount.plus(count.multipliedBy(price));
      });
      sums[columns.length - 3] = totalAmount.toFixed(2);
      return sums;
    },
    computePrice(row) {
      if (!row.count || !row.amount) {
        return "-";
      }
      let c = new BigNumber(row.count);
      let p = new BigNumber(row.amount);
      return c.multipliedBy(p).toFixed(2);
    },
    delRow(index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1);
      }
    },
    reset() {
      this.dataForm = {
        id: "",
        totalAmount: "",
        code: "",
        currency: "人民币",
        signTime: moment().format("yyyy-MM-DD"),
        customerId: "",
        detailList: [],
        purchaseList: [],
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.$nextTick(() => {
        this.reset();
        if (this.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/agreement/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        })
        .catch(() => {});
    },
    cancel() {
      this.$router.back();
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let postForm = this.$clone(this.dataForm);
          if (postForm.detailList && postForm.detailList.length === 0) {
            return this.$message.error("合同明细不能为空");
          }
          postForm.detailList.forEach((item) => {
            if (item.id < 10000) {
              item.id = "";
            }
            item.amount = new BigNumber(item.amount)
              .multipliedBy(100)
              .toFixed();
          });
          if (this.projectId) {
            postForm.projectId = this.projectId;
          }
          const loading = this.$loading();
          this.$http[!postForm.id ? "post" : "put"](
            "/trade/agreement/",
            postForm
          )
            .then(({ data: res }) => {
              loading.close();
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.cancel()
                },
              });
            })
            .catch((e) => {
              loading.close();
              console.log(e);
            });
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>

<style lang="scss" scoped>
.app-body {
  padding: 0;
}
</style>
